/**
 * Promised component makes it easier to render content that
 * depends on resolution of a Promise.
 *
 * How to use:
 * <Promised promise={givenPromise} renderFulfilled={v => <b>{v}</b>} renderRejected={v => <b>v</b>} />
 */

import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Promised = ({ promise, renderFulfilled, renderRejected = e => e }) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    promise
      .then(val => {
        if (isMounted) setValue(val);
      })
      .catch(err => {
        if (isMounted) setError(err);
      });
    return () => {
      isMounted = false;
    };
  }, [promise]);

  return error ? renderRejected(error) : renderFulfilled(value);
};

const { shape, func } = PropTypes;

Promised.propTypes = {
  promise: shape({
    then: func.isRequired, // usually promises are detected from this single function alone
  }).isRequired,
  renderFulfilled: func.isRequired,
  renderRejected: func.isRequired,
};

export default Promised;
